import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import OrderDetailPage from './OrderDetailPage';
import './OrderDetailPage.less';

export const prefix = 'bm-p-new-order-detail';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: OrderDetailPage,
  routeProps: props,
  pageTitleI18nKey: '',
});

export default RouteComponent;
